module.exports = __webpack_public_path__ + "static/media/aptitude.48804b5e.png";